/**
 * 
 * @returns the exact same "random avatars" based on the baseNumber passed in argument
 */

const avatars = [
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+1.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+40.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+3.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+4.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+5.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+6.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+7.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+8.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+9.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+10.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+11.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+12.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+13.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+14.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+15.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+16.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+17.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+18.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+19.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+20.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+21.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+22.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+23.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+24.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+25.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+26.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+27.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+28.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+29.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+30.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+31.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+32.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+33.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+34.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+35.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+36.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+37.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+38.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+39.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+40.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+41.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+42.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+43.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+44.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+45.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+46.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+47.png" },
  { picture: "https://microdoing.s3.eu-west-3.amazonaws.com/avatars/Frame+48.png" },
];

interface IParams {
  baseNumber: number;
  numberOfAvatars?: number;
}

const getRandomAvatarsFromNumber = ({ baseNumber, numberOfAvatars = 4 }: IParams) => {
  let finalAvatars = [...avatars];
  let randomNumber = baseNumber;

  if (!baseNumber) return avatars;

  if (baseNumber > avatars.length) {
    randomNumber = parseInt(baseNumber?.toString()?.[0]);
  }
  if (randomNumber > avatars.length) {
    return avatars;
  }

  finalAvatars = finalAvatars.slice(randomNumber, randomNumber + 4);

  if (finalAvatars.length < numberOfAvatars) {
    const numberOfAvatarsNeeded = numberOfAvatars - finalAvatars.length;
    finalAvatars = [...avatars, ...avatars.slice(0, numberOfAvatarsNeeded)]
  }

  return finalAvatars;
};

export default getRandomAvatarsFromNumber;
